
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/badges",
      function () {
        return require("private-next-pages/badges/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/badges"])
      });
    }
  